import { render } from "./TableData.vue?vue&type=template&id=87fdde9e&scoped=true"
import script from "./TableData.vue?vue&type=script&lang=js"
export * from "./TableData.vue?vue&type=script&lang=js"

import "./TableData.vue?vue&type=style&index=0&id=87fdde9e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src5135303/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87fdde9e"]])

export default __exports__